import type { ComponentCommonProps, Media, Shape, Theme } from '../../types/props.js'

export interface MemberEquityProps extends ComponentCommonProps, React.HTMLAttributes<HTMLDivElement> {
  data: {
    /** 标题 */
    title: string
    /** 描述文本 */
    description: string
    /** 背景图片/视频 URL */
    backgroundImage?: Media
    mobileBackgroundImage?: Media
    /** 主按钮配置 */
    primaryButton: {
      text: string
      link?: string
    }
    primaryButtonHandler?: () => void
    /** 副按钮配置 */
    secondaryButton: {
      text: string
      link?: string
    }
    secondaryButtonHandler?: () => void
    /** 形状 */
    shape?: Shape
    /** 主题 */
    theme?: Theme
  }
  /** 自定义类名 */
  className?: string
}
